(function () {
    const items = jQuery('.usp-bar__item');
    const fadeIn = 3000;
    const showFor = 2000;
    const fadeOut = 1000;

    function doAnimation(index = 0) {
        jQuery(items[index]).css({zIndex: 1, opacity: 0}).animate({opacity: 1}, fadeIn, function () {
            jQuery(this).delay(showFor).queue(function (next) {
                jQuery(this).css({zIndex: 0}).animate({opacity: 0}, fadeOut);
                next();
            }).queue(function (next) {
                if (index === jQuery(items).length - 1) {
                    doAnimation();
                } else {
                    doAnimation(index + 1);
                }
                next();
            });
        });
    }
    doAnimation();
}());
